import { ref, computed } from 'vue'

interface ProjectFilesResponse {
  files: File[]
  count: number
  project: string
}

export interface File {
  id?: number
  name: string
  size?: number | null
  size_human?: string
  type?: string
  date?: string | null
  date_string?: string | null
  extension?: string
  url?: string | null
  parts?: string[]
  error?: string
  [key: string]: string | number | object | string[] | null | undefined
}

export function useFiles() {
  const files = ref<File[]>([]) // items is now Ref<Item[]>
  const projectFileList = ref<File[]>([])
  const getItems = async (): Promise<File[]> => {
    // return an empty array if we're running in a test environment
    return []

    // const response = await fetch('/api/list-files/?format=json')
    // // Assert the response is OK
    // if (!response.ok) {
    //   throw new Error('Failed to fetch Site')
    // }
    // // Assert the response is JSON
    // if (!response.headers.get('content-type')?.includes('application/json')) {
    //   // throw new Error('Invalid content type')
    // }

    // return await response.json()
  }

  const fetchFiles = async () => {
    files.value = await getItems()
    // remove any files prefixed with a dot
    console.log(files.value)
    files.value = files.value.filter(file => !file.name.startsWith('.'))
    console.log(files.value)
    // sort the sites by name

  }

  const fileKeys = computed(() => {
    return files.value.length > 0 ? Object.keys(files.value[0]) : []
  })

  const getProjectFileList = async (projectName: string): Promise<ProjectFilesResponse> => {
    const response = await fetch(`/api/project-files/?project=${projectName}`)
    // Assert the response is OK
    if (!response.ok) {
      throw new Error('Failed to fetch Site')
    }
    // Assert the response is JSON
    if (!response.headers.get('content-type')?.includes('application/json')) {
      throw new Error('Invalid content type')
    }
    return await response.json()
  }

  const fetchProjectFiles = async (projectName: string) => {
    const response = await getProjectFileList(projectName)
    console.log(response)
    // response should have a files property
    if (!response.files) {
      console.log('No files property in response')
      throw new Error('Invalid response')
    }

    // Clear existing files
    projectFileList.value = []

    // loop through each item in the response files array
    for (const item of response.files) {
      // item should now be an object with detailed file info
      if (typeof item === 'string') {
        // Backwards compatibility - if it's still a string
        console.log('String item (legacy):', item)
        if (!item.startsWith('.')) {
          projectFileList.value.push({ name: item })
        }
      } else {
        // New format - detailed file object
        console.log('Detailed file item:', item.name, 'Type:', item.type, 'Date:', item.date_string)
        projectFileList.value.push(item)
      }
    }
  }

  const projectFileKeys = computed(() => {
    return projectFileList.value.length > 0 ? Object.keys(projectFileList.value[0]) : []
  })

  return { files, fetchFiles, fileKeys, projectFileList, fetchProjectFiles, projectFileKeys }
}
